import * as yup from "yup";
import {
  getStringRequiredFieldMessage,
  validatePhoneNumber,
} from "@shared/utils/yup-extensions";

type ManageUserFormSchemaParams = {
  // Individual-plan users aren't tied to an MLS provider, so their edit form
  // shouldn't require one - only plans with MLS access (e.g. brokerage) do.
  requireMlsProvider: boolean;
};

export const getManageUserFormSchema = ({
  requireMlsProvider,
}: ManageUserFormSchemaParams) =>
  yup
    .object()
    .shape({
      name: yup
        .string()
        .trim()
        .min(1, getStringRequiredFieldMessage)
        .required()
        .label("Name"),
      timezone: yup
        .string()
        .trim()
        .min(1, getStringRequiredFieldMessage)
        .required()
        .label("Time Zone"),
      countryState: yup
        .string()
        .trim()
        .min(1, getStringRequiredFieldMessage)
        .required()
        .label("State"),
      phoneNumber: yup
        .string()
        .test(
          validatePhoneNumber({
            message: "Invalid phone number",
            region: "US",
            optional: true,
          })
        )
        .optional(),
      mlsId: yup
        .string()
        .trim()
        .min(1, getStringRequiredFieldMessage)
        .required()
        .label("License Number"),
      enabledMlsProvidersSelected: requireMlsProvider
        ? yup
            .array()
            .of(yup.string().required())
            .min(1, "At least one MLS Provider must be selected")
            .label("Enabled MLS Providers")
        : yup
            .array()
            .of(yup.string().required())
            .label("Enabled MLS Providers"),
    })
    .required();

export type ManageUserFormSchema = ReturnType<
  typeof getManageUserFormSchema
>["__outputType"];

export const MANAGE_USER_SCHEMA_DEFAULT_VALUES = {
  name: "",
  timezone: "",
  countryState: "",
  phoneNumber: "",
  mlsId: "",
  enabledMlsProvidersSelected: [],
} satisfies ManageUserFormSchema;
